import DataStore, { Query, QueryResult } from 'src/core/stores/data-store';

export enum AuditLogType {
  UserLogin = 'UserLogin',
  UserAccessOrganization = 'UserAccessOrganization',
  UserLogout = 'UserLogout',
  UserAddedToGroup = 'UserAddedToGroup',
  UserRemovedFromGroup = 'UserRemovedFromGroup',
  RoleAssignedToUser = 'RoleAssignedToUser',
  RoleUnassignedToUser = 'RoleUnassignedToUser',
  RoleAssignedToGroup = 'RoleAssignedToGroup',
  RoleUnassignedToGroup = 'RoleUnassignedToGroup',
  InvitationSent = 'InvitationSent',
  InvitationAccepted = 'InvitationAccepted',
  BackupSuccess = 'BackupSuccess',
  BackupError = 'BackupError',
  RestoreBackupStart = 'RestoreBackupStart',
  BackupStart = 'BackupStart',
  RestoreBackupSuccess = 'RestoreBackupSuccess',
  RestoreBackupError = 'RestoreBackupError',
}

export interface AuditLogSummary {
  id: string;
  timestamp: string;

  userId: string;
  userDisplayName: string;

  type: AuditLogType;

  organizationId?: string;
  organizationDisplayName: string;

  relatedEntityId: string;
  relatedEntityTitle: string;

  description: string;
}

export class AuditLogSummaryStore extends DataStore<AuditLogSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/audit-logs`, []);
  }

  public async getLogs(query: Partial<Query>) {
    return await this.handleCallAsync(async () => {
      try {
        const response = await this.httpService.get<QueryResult<AuditLogSummary>>(`${this.baseUrl}?${DataStore.buildUrl(query as Query)}`);
        return response.data.items;
      } catch {
        return [];
      }
    });
  }
}
